import React from "react";
import PropTypes from "prop-types";
import { Button } from "cxa-components";
import { range } from "cxa-utils";
import HeaderForm from "../common/HeaderForm";
import Policy from "./Policy";
import Employee from "./Employee";
import Dependent from "./Dependent";
import MedicalQuestionnaire from "./MedicalQuestionnaire";
import Declaration from "./Declaration";
import Warning from "./Warning";
import Signature from "./Signature";
import { SUBMIT_FAILURE_MESSAGE } from "../../constants";
import { InputField } from "../../FormField";

const formName = 'ENROLMENT / HEALTH DECLARATION FORM';

const Form = ({ data, isReadOnly, onClose, onPrint, onSave, submitting, submitFailed }) => {
  return (
    <div className="hdf">
      <HeaderForm formName={formName} />
      <Policy data={data} />
      <Employee data={data} />
      <Dependent data={data} />
      <MedicalQuestionnaire data={data} />

      <fieldset>
        <strong>
          {
            'If any of the above answers is "Yes", please give full details in the space provided below'
          }
        </strong>
        <table>
          <tbody>
            <tr>
              <td width="10%" className="text--center">
                Qn No.
              </td>
              <td width="25%" className="text--center">
                Name of Insured
              </td>
              <td width="65%" className="text--center">
                Please provide date of consultation, details of diagnosis/exact condition, result,
                name and address of doctor seen
              </td>
            </tr>

            {range(1, 8).map(number => {
              const MoreInfoSubQNo = `MoreInfoSubQNo${number}`;
              const MoreInfoName = `MoreInfoName${number}`;
              const MoreInfoDiagnosis = `MoreInfoDiagnosis${number}`;

              return (
                <tr key={number}>
                  <td>
                    <InputField name={MoreInfoSubQNo} {...data[MoreInfoSubQNo]} />
                  </td>

                  <td>
                    <InputField name={MoreInfoName} {...data[MoreInfoName]} />
                  </td>

                  <td>
                    <InputField name={MoreInfoDiagnosis} {...data[MoreInfoDiagnosis]} />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </fieldset>

      <Declaration isReadOnly={isReadOnly} />
      <Warning />
      <Signature data={data} />

      {submitFailed && (
        <p role="alert" className="card--alert">
          {SUBMIT_FAILURE_MESSAGE}
        </p>
      )}

      <p>
        {!isReadOnly ? (
          <React.Fragment>
            <Button type="button" onClick={onSave} disabled={submitting} secondary>
              Save
            </Button>
            <Button primary type="submit" submitting={submitting} disabled={submitting}>
              Submit & Confirm
            </Button>
          </React.Fragment>
        ) : (
          <Button primary type="button" onClick={onPrint}>
            Print
          </Button>
        )}

        <Button onClick={onClose} disabled={submitting} secondary>
          Close
        </Button>
      </p>
    </div>
  );
};

Form.propTypes = {
  submitFailed: PropTypes.bool.isRequired,
  submitSucceeded: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onPrint: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  isReadOnly: PropTypes.bool,
  data: PropTypes.object,
};

export default Form;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/Aia/AIAHD201706_NOCHILD/index.js